import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useModelDeleteAsyncActionFailed } from "./model-delete-async-action-failed.hook";

export const ModelDeleteAsyncActionFailed = () => {
  const { runAction } = useModelDeleteAsyncActionFailed();
  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.ASYNC_DELETE_FAILED,
    runAction
  );

  return <></>;
};
